export default "__VITE_ASSET__DOylVjSg__"